import Input from '../Input/Input';
import './Footer.css';
import { Link } from 'react-router-dom';
import { useContext, useState } from 'react';
import validator from "validator";

import mainApi from '../../assets/api/MainApi';
import { LANDING_URL, PRIVACY_POLICY_LINK, STATIC_DOCS_LINK, USER_AGREEMENT_LINK } from '../../assets/utils/constants';
import { ConfigContext } from '../../assets/contexts/configContext';
import { FacebookIcon } from '../../assets/icons/socialNetworks/socialNetworks';
import { DEFAULT_SOCIAL_VALUES_MAP } from '../../assets/utils/socials/socials_constants';
import { isExternalURL } from '../../assets/utils/utils';


function Footer() {
  const config = useContext(ConfigContext)
  const { initialConstants } = config
  const { CONSTANTS } = initialConstants
  const { SHOW_SOCIALS_ICON_IN_FOOTER = true, SHOW_SOCIALS_NAME_IN_FOOTER = false } = CONSTANTS
  const { STATIC_PAGES, SOCIAL_NETWORKS, FOOTER_LINKS } = initialConstants
  const [form, setForm] = useState({
    email: "",
  });
  const [formValid, setFormValid] = useState({
    email: {},
  });
  function handleChange(e) {
    const input = e.target;
    const name = input.name;
    let value = input.value;

    switch (name) {
      case "email":
        if (!value) {
          setFormValid((prevValue) => ({
            ...prevValue,
            email: {
              errorMassage: "",
              validState: false,
            },
          }));
        }
        if (value.length >= 2) {
          if (validator.isEmail(value)) {
            setFormValid((prevValue) => ({
              ...prevValue,
              email: {
                errorMassage: "",
                validState: true,
              },
            }));
          } else {
            setFormValid((prevValue) => ({
              ...prevValue,
              email: {
                errorMassage: !e.target.validity.valid
                  ? e.target.validationMessage
                  : "Invalid email",
                validState: false,
              },
            }));
          }
        }
        setForm((prevValue) => ({
          ...prevValue,
          [name]: value,
        }));
        break;

      default:
        setForm((prevValue) => ({
          ...prevValue,
          [name]: value,
        }));
        break;
    }
  }

  const isFormVlid =
    formValid.email.validState;



  function hendleSubmit() {
    setForm({
      email: "",
    });
    setFormValid({
      email: {},
    });
    mainApi.subscribeToNewsletter({ email: form.email })
      .then((res) => {
        console.log(res)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const FOOTER_LINKS_DEFAULT = [
    {
      text: 'Пользовательское соглашение',
      link: `/${USER_AGREEMENT_LINK}`,
    },
    {
      text: 'Политика обработки персональных данных',
      link: `/${PRIVACY_POLICY_LINK}`,
    },
    // {
    //   text: '© Ваш Ковер, 2023'
    // },
    // {
    //   text: 'О нас'
    // },
    // {
    //   text: 'vash-kover@bk.ru'
    // },
    // {
    //   text: '+7 (925) 566-99-93'
    // },
    // {
    //   text: 'Telegram'
    // },
    // {
    //   text: 'Оплата и доставка'
    // },
    // {
    //   text: 'Как сделать заказ'
    // },
    // {
    //   text: 'Условия возврата'
    // },
    // {
    //   text: 'Обратная связь'
    // },
    // {
    //   text: 'Пользовательское соглашение'
    // },
    // {
    //   text: 'Обработка данных'
    // },
  ]

  return (
    <footer className="footer">
      <div className='footer__box'>
        <div className='footer__content-box'>
          <div className="footer__content">
            {STATIC_PAGES && STATIC_PAGES.length > 0 ?
              STATIC_PAGES.map((item, i) => {
                return (
                  <Link className='footer__link' key={i} to={`/${STATIC_DOCS_LINK}/${item.translit_name}`}>
                    {item.name}
                  </Link>
                )
              })
              :
              FOOTER_LINKS_DEFAULT.map((item, i) => {
                return (
                  item.link ?
                    <Link className='footer__link' key={i} to={item.link}>
                      {item.text}
                    </Link> :
                    item.href ?
                      <a key={i} href={item.href} >{item.text}</a> :
                      <p key={i}>{item.text}</p>
                )
              })}


          </div>
          {SOCIAL_NETWORKS && Array.isArray(SOCIAL_NETWORKS) && SOCIAL_NETWORKS.length > 0 ?
            <div className='footer__socials'>
              {SOCIAL_NETWORKS.map((social, i) => {
                const SOCIAL = DEFAULT_SOCIAL_VALUES_MAP[social.type]
                return (
                  <a className='footer__social' href={social.url} target='_blank' rel='noreferrer' key={`footer__social${social._id}${i}`}>
                    {SHOW_SOCIALS_ICON_IN_FOOTER ?
                      SOCIAL.icon({ mainClassName: 'footer__social-icon', fillClassName: 'footer__social-icon-fill', bgFillClassName: 'footer__social-icon-bg-fill' }) : null}
                    {SHOW_SOCIALS_NAME_IN_FOOTER ? <p className='footer__social-title'>{SOCIAL.title}</p> : null}
                  </a>
                )
              })}
            </div>
            :
            null
          }
          {FOOTER_LINKS && Array.isArray(FOOTER_LINKS) && FOOTER_LINKS.length > 0 ?
            <div className='footer__links'>
              {FOOTER_LINKS.map((link, i) => (
                <Link
                  className='footer__link'
                  key={`footer__social${link._id}${i}`}
                  to={link.url}
                  target={isExternalURL(link.url) ? '_blank' : '_self'} // Conditionally set target attribute
                  rel={isExternalURL(link.url) ? 'noopener noreferrer' : undefined} // Add rel for security if external
                >
                  {link.name}
                </Link>
              )
              )}
            </div>
            :
            null
          }
        </div>

        <a className='footer__polza' href={LANDING_URL} target='_blank' rel='noreferrer'>
          <svg width="100" height="22" viewBox="0 0 100 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="83.8508" width="3.72671" height="3.72671" fill="#FF8585" />
            <rect x="90.062" width="3.72671" height="3.72671" fill="#FFB84F" />
            <rect x="96.2729" width="3.72671" height="3.72671" fill="#7AE448" />
            <path className='footer__polza-fill' d="M0 20.7632V3.72681H14.0377V20.7632H11.1387V6.40057H2.89896V20.7632H0Z" fill="black" />
            <path className='footer__polza-fill' d="M22.6656 21.1181C21.3665 21.1181 20.2317 20.8302 19.2614 20.2544C18.2911 19.6787 17.5373 18.886 17 17.8765C16.4707 16.859 16.2061 15.6917 16.2061 14.3745C16.2061 13.0337 16.4787 11.8585 17.024 10.849C17.5693 9.83939 18.3272 9.05067 19.2975 8.48279C20.2678 7.91491 21.3905 7.63097 22.6656 7.63097C23.9727 7.63097 25.1114 7.91886 26.0818 8.49462C27.0521 9.07039 27.8059 9.867 28.3432 10.8844C28.8805 11.894 29.1491 13.0574 29.1491 14.3745C29.1491 15.6996 28.8765 16.8708 28.3312 17.8883C27.7939 18.8978 27.0401 19.6905 26.0697 20.2663C25.0994 20.8342 23.9647 21.1181 22.6656 21.1181ZM22.6656 18.4443C23.8203 18.4443 24.6784 18.0657 25.2397 17.3086C25.8011 16.5514 26.0818 15.5734 26.0818 14.3745C26.0818 13.1362 25.7971 12.1503 25.2277 11.4168C24.6583 10.6754 23.8043 10.3047 22.6656 10.3047C21.8877 10.3047 21.2462 10.4783 20.7409 10.8253C20.2438 11.1644 19.8749 11.6416 19.6343 12.2568C19.3937 12.8641 19.2734 13.57 19.2734 14.3745C19.2734 15.6128 19.5581 16.6027 20.1275 17.3441C20.7049 18.0776 21.5509 18.4443 22.6656 18.4443Z" fill="black" />
            <path className='footer__polza-fill' d="M30.1154 20.7632V18.3733C30.5885 18.4601 30.9534 18.4522 31.21 18.3497C31.4666 18.2393 31.6591 18.0342 31.7874 17.7345C31.9157 17.4348 32.028 17.0365 32.1242 16.5396C32.2525 15.8376 32.3648 15.0292 32.461 14.1143C32.5653 13.1993 32.6535 12.2213 32.7256 11.1802C32.8058 10.1391 32.878 9.07433 32.9422 7.9859H42.5051V20.7632H39.6182V10.6597H35.4923C35.4522 11.1723 35.4041 11.7481 35.3479 12.387C35.2918 13.0179 35.2317 13.6568 35.1675 14.3036C35.1033 14.9503 35.0312 15.5655 34.951 16.1492C34.8788 16.7249 34.8026 17.2179 34.7224 17.628C34.538 18.5508 34.2734 19.2804 33.9285 19.8167C33.5917 20.353 33.1186 20.6961 32.5091 20.846C31.8997 21.0037 31.1017 20.9761 30.1154 20.7632Z" fill="black" />
            <path className='footer__polza-fill' d="M45.3913 20.7632L45.3792 7.9859H48.2782V12.245H50.6118C50.9727 12.245 51.3776 12.2529 51.8267 12.2687C52.2838 12.2844 52.6647 12.3199 52.9695 12.3751C53.6992 12.5329 54.3207 12.7853 54.8339 13.1323C55.3552 13.4793 55.7521 13.9329 56.0248 14.4928C56.2974 15.0528 56.4338 15.7272 56.4338 16.5159C56.4338 17.6438 56.1371 18.5469 55.5436 19.2252C54.9582 19.8956 54.1323 20.353 53.0657 20.5975C52.7449 20.6685 52.352 20.7158 51.8869 20.7395C51.4298 20.7553 51.0168 20.7632 50.6479 20.7632H45.3913ZM48.2782 18.5272H50.9005C51.0769 18.5272 51.2734 18.5193 51.4899 18.5035C51.7064 18.4877 51.9149 18.4522 52.1154 18.397C52.4763 18.3024 52.793 18.0894 53.0657 17.7581C53.3464 17.419 53.4867 17.0049 53.4867 16.5159C53.4867 16.0032 53.3464 15.5813 53.0657 15.25C52.785 14.9188 52.4402 14.7019 52.0312 14.5993C51.8468 14.552 51.6543 14.5204 51.4538 14.5047C51.2533 14.4889 51.0689 14.481 50.9005 14.481H48.2782V18.5272Z" fill="black" />
            <path className='footer__polza-fill' d="M63.2147 21.1181C61.9797 21.1181 60.853 20.8618 59.8346 20.3491C58.8161 19.8364 58.0142 19.1345 57.4288 18.2432L59.7143 16.7407C60.1794 17.2849 60.6966 17.7069 61.266 18.0066C61.8354 18.2984 62.4689 18.4443 63.1666 18.4443C63.8963 18.4443 64.4697 18.2866 64.8867 17.9711C65.3037 17.6556 65.5122 17.2336 65.5122 16.7052C65.5122 16.2399 65.3718 15.9125 65.0912 15.7232C64.8105 15.5261 64.4416 15.4078 63.9845 15.3683C63.5274 15.3289 63.0382 15.3092 62.517 15.3092H61.5547V13.0495H62.505C63.2347 13.0495 63.8442 12.9667 64.3334 12.801C64.8305 12.6354 65.0791 12.2687 65.0791 11.7008C65.0791 11.1881 64.8867 10.8253 64.5018 10.6123C64.1168 10.3915 63.6678 10.2811 63.1545 10.2811C62.529 10.2811 61.9115 10.4112 61.3021 10.6715C60.6926 10.9318 60.1473 11.2473 59.6662 11.618L58.0302 9.6777C58.752 9.04673 59.5579 8.54983 60.448 8.18702C61.3382 7.81632 62.2884 7.63097 63.2989 7.63097C64.1329 7.63097 64.9107 7.77294 65.6325 8.05688C66.3622 8.34082 66.9476 8.76673 67.3887 9.33461C67.8378 9.90249 68.0623 10.6045 68.0623 11.4405C68.0623 12.0399 67.93 12.6039 67.6654 13.1323C67.4087 13.6607 66.9957 14.1616 66.4264 14.6348L66.3903 13.712C66.8313 13.8934 67.2042 14.1458 67.509 14.4692C67.8217 14.7926 68.0583 15.1711 68.2187 15.6049C68.3871 16.0387 68.4713 16.5001 68.4713 16.9891C68.4713 17.8804 68.2307 18.6336 67.7495 19.2488C67.2684 19.864 66.6269 20.3294 65.8249 20.6449C65.031 20.9604 64.1609 21.1181 63.2147 21.1181Z" fill="black" />
            <path className='footer__polza-fill' d="M74.2694 21.1181C73.3311 21.1181 72.5372 20.9446 71.8877 20.5975C71.2381 20.2426 70.7449 19.7733 70.4081 19.1897C70.0793 18.606 69.9149 17.9632 69.9149 17.2613C69.9149 16.6461 70.0192 16.0939 70.2277 15.6049C70.4362 15.108 70.757 14.6821 71.19 14.3272C71.623 13.9644 72.1844 13.6686 72.874 13.4399C73.3953 13.2743 74.0047 13.1244 74.7024 12.9903C75.4081 12.8562 76.1699 12.734 76.9879 12.6236C77.8139 12.5053 78.6759 12.3791 79.5741 12.245L78.5396 12.8247C78.5476 11.9413 78.3472 11.2906 77.9382 10.8726C77.5292 10.4546 76.8395 10.2456 75.8692 10.2456C75.2838 10.2456 74.7185 10.3797 74.1731 10.6478C73.6278 10.916 73.2469 11.3774 73.0304 12.032L70.3841 11.2157C70.7048 10.1352 71.3143 9.26757 72.2124 8.61293C73.1186 7.95829 74.3375 7.63097 75.8692 7.63097C77.024 7.63097 78.0384 7.81632 78.9125 8.18702C79.7946 8.55772 80.4482 9.16504 80.8732 10.009C81.1058 10.4585 81.2461 10.9199 81.2942 11.3932C81.3423 11.8585 81.3664 12.3672 81.3664 12.9193V20.7632H78.8283V17.9948L79.2493 18.4443C78.6639 19.3671 77.9783 20.0454 77.1924 20.4792C76.4145 20.9051 75.4402 21.1181 74.2694 21.1181ZM74.8468 18.8466C75.5043 18.8466 76.0657 18.7322 76.5308 18.5035C76.9959 18.2748 77.3648 17.9948 77.6375 17.6635C77.9181 17.3322 78.1066 17.0207 78.2028 16.7289C78.3552 16.3661 78.4394 15.952 78.4554 15.4866C78.4795 15.0134 78.4915 14.6309 78.4915 14.339L79.3816 14.5993C78.5075 14.7334 77.7578 14.8517 77.1322 14.9542C76.5067 15.0568 75.9695 15.1554 75.5204 15.25C75.0713 15.3368 74.6744 15.4354 74.3295 15.5458C73.9927 15.6641 73.708 15.8021 73.4755 15.9599C73.2429 16.1176 73.0625 16.299 72.9342 16.5041C72.8139 16.7091 72.7537 16.9497 72.7537 17.2258C72.7537 17.5412 72.8339 17.8212 72.9943 18.0657C73.1547 18.3024 73.3873 18.4917 73.692 18.6336C74.0047 18.7756 74.3897 18.8466 74.8468 18.8466Z" fill="black" />
          </svg>

        </a>
      </div>

    </footer>
  );
}

export default Footer